import React from 'react';
import { Button, Result } from 'antd';
import loginEvent, { BackToHome } from '@/events/login-event';

const UnauthorizedPage = () => {
  return (
    <Result
      status="403"
      title="访问受限"
      subTitle="抱歉，您无权访问该页面"
      extra={<Button type="primary" onClick={() => loginEvent.emit(BackToHome)}>返回首页</Button>}
    />
  );
};

export default UnauthorizedPage;
